module.exports = __webpack_public_path__ + "img/mood_angry.851cf6df.png";